// @flow

export const MAINTENANCE = {
    sideMenuItems: [
        {
            translationId: 'views.Maintenance.SideMenu.Alarm',
            url: '/maintenance/alarms',
        },
        {
            translationId: 'views.Maintenance.SideMenu.Report',
            url: '/maintenance/report',
        },
    ],
};
